import { TextStyleProps } from "@twilio-paste/core/text";
import { BoxStyleProps } from "@twilio-paste/core/box";

export const titleStyles: TextStyleProps = {
    fontSize: "fontSize60",
    marginBottom: "space60"
};

export const boxStyles: BoxStyleProps = {
    padding: "space40",
    paddingTop: "space80",
    overflow: "auto",
    textAlign: "center"
};

export const actionBoxStyles: BoxStyleProps = {
    paddingTop: "space200",
    textAlign: "center"
};
